import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreService } from './core.service';

@Injectable({
  providedIn: 'root',
})
export class CoreResolverService implements Resolve<any> {
  constructor(private coreService: CoreService) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return combineLatest([
      this.coreService.getAllDropdownValues(),
      this.coreService.fetchUserRoles(),
    ]).pipe(
      map((allResponses) => {
        this.coreService.setDropdownValues(allResponses[0].value);
        this.coreService.setUserRoleValues(allResponses[1].value);
        return true;
      })
    );
  }
}
